import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {LocationModel} from "../../../models/location.model";
import {LocationHolderType} from "../../../types/locationHolder.type";

export const LocationsChannelActions = createActionGroup({
  source: '[Location/Channel]',
  events: {
    subscribe: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: LocationModel }>(),
  }
});

export const LocationsAPiActions = createActionGroup({
  source: '[Location/API]',
  events: {

    //Get locations
    getLocations: props<{ payload?: { holderId: string, holder: LocationHolderType }[] }>(),
    getLocationsSuccess: props<{ locations: LocationModel[] }>(),
    getLocationsFailure: props<{ error: any }>(),

    //Get location
    getLocation: props<{ holderId: string, holder: LocationHolderType }>(),
    getLocationSuccess: props<{ location: LocationModel }>(),
    getLocationFailure: props<{ error: any }>()

  },
});

export const LocationActions = createActionGroup({
  source: '[Location]',
  events: {
    setLocations: props<{locations: LocationModel[]}>(),
    removeLocations: props<{ ids: string[] }>(),
    removeAll: emptyProps()
  }
});

